<template>
    <div class="text-center" v-if="!is_data_ready">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

    <div class="category_list_main sabc_videos_page_body" v-else-if="is_data_ready">
        <!-- sabc tv show slider start -->
        <section class="sabc_video_showbanner_sec">
			<picture>
				<source
				  media="(max-width: 575px)"
				  :srcset="imagePath(base_url + category.image, false)"
				/>
				<img
				  class="video_thumbnail"
				  :src="imagePath(base_url + category.image, true)"
				  :alt="category.title"
				  :title="category.title"
				  width="444"
				  height="249"
				  fetchpriority="high"
				  decoding="async"
				/>
			</picture>
            <div class="sabc_video_showbanner_desc">
                <div class="container">
                    <h1>{{category.title}}</h1>
                    <p></p>
                    <router-link :to="{ name: 'videolising'}"> &lt; Back</router-link>
                </div>
            </div>
        </section>
        <!-- sabc tv show slider end  -->
        <!-- video area start -->
        <section class="container">
            <div class="sabc_videos_show_latest">
                <h2>Latest Episodes</h2>
                <div class="sabc_videos_show_latest_row" v-for="video in video_list"  v-if="video.image != null">
                    <router-link class="sabc_show_latest_video_outer" :to="{ name: 'video_player', params: { category: category.slug, player: video.slug}}">
                        <div class="sabc_show_latest_video">
                            <img class="play_icon" src="/assets/img/sabc_video_list_play_icon.png" alt="SABC Play Icon" title="SABC Play Icon"/>
							<picture>
								<img
								  class="video_thumbnail"
								  :src="imagePath(base_url + video.image, false)"
								  :alt="video.title"
								  width="444"
								  height="249"
								  fetchpriority="high"
								  decoding="async"
								/>
						    </picture>
                        </div>
                    </router-link>
                    <div class="sabc_show_latest_desc">
                        <router-link :to="{ name: 'video_player', params: { category: category.slug, player: video.slug}}"><h3>{{video.title}}</h3></router-link>
                        <p></p>
                        <ul>
                            <li>
                                <p>
                                    <img src="/public/images/sabc_showvideos_timer.png" alt="SABC Show Video Time"/>
                                     {{new Date(video.duration*1000).toISOString().slice(11, 19)}}<i>|</i> {{video.release_date}}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!-- video area end -->
    </div>
</template>

<script>
    export default {
        name: 'videolising',
        data() {
            return {
                base_url: '',
                video_list: [],
                category: [],
                is_data_ready:false
            }
        },
        components: {},
        mounted() {
            this.getVideoData();
        },
       watch: {
       },
        serverPrefetch() {
            this.getVideoData();
        },
        computed: {
        },
        metaInfo() {
           if (this.$store.state.siteSetting) {
                let ss = this.$store.state.siteSetting;

                let title = this.$getSafe(() => ss.sabc_video_category_listing_meta_title);
                let description = this.$getSafe(() => ss.sabc_video_category_listing_meta_description);
                let keywords = this.$getSafe(() => ss.sabc_video_category_listing_meta_keywords);

                return {
                    title: title,
                    description: description,
                    meta: this.$getMetaTags(title, description, keywords),
                    link: [
                        {rel: 'canonical', href: this.$toFullPath(this.$route.fullPath)}
                    ],
                }
            }
        },
		jsonld() {
            if (isServer)
                return {
                    "@context": "https://schema.org",
                    "@graph": []
                }

            if (!this.video_list){
				return {
                    "@context": "https://schema.org",
                    "@graph": []
                }
			}
            let events = [];
            if(this.video_list){
				this.video_list.slice(0,10).forEach((videoItem) => {
					const embedUrl = `https://www.sabcsport.com/video/${this.category.slug}/${videoItem.slug}`;
					const thumbnailUrl = this.imagePath(this.base_url + videoItem.image, true);

					events.push({
						"@context": "https://schema.org/",
						"@type": "VideoObject",
						"name": videoItem.title,
						"@id": embedUrl,
						"datePublished": videoItem.release_date,
						"uploadDate": videoItem.updated_at,
						"description": videoItem.title,
						"embedUrl": embedUrl,
						"thumbnailUrl": thumbnailUrl,
						"author": {
							"@type": "Person",
							"name": videoItem.provider && videoItem.provider.trim() !== "" ? videoItem.provider : "SABC Sport"
						}
					});
				});
				return {
					"@context": "https://schema.org",
					"@graph": events
				};
			}
        },
        methods: {
            getVideoData() {
                let params = {category: this.$route.params.category}
                return this.$axios.get(this.$GetVideoCategoryList, {params})
                        .then(response => {
                            if (response.data) {
                                if(response.data.video_list != undefined){
                                    this.base_url = response.data.base_url;
                                    this.video_list = response.data.video_list;
                                    this.category = response.data.category;
									const isMobile = this.isMobileDevice();
									const lcpImageUrl = this.imagePath(this.base_url + this.category.image, !isMobile);
									this.addPreloadLink(lcpImageUrl);
                                }
                                this.is_data_ready = true;
                            }
                        })
                        .catch(error => {
                        })
            },
			addPreloadLink(url) {
				const existing = document.querySelector(`link[rel="preload"][href="${url}"]`);
				if (existing) return;

				const link = document.createElement('link');
				link.rel = 'preload';
				link.as = 'image';
				link.href = url;
				link.type = 'image/webp';
				link.fetchPriority = 'high';
				document.head.appendChild(link);
			},
			isMobileDevice() {
			  return window.innerWidth <= 575;
			},
            imagePath(path, callFlag = false) {
				path = path.replace(/\\/g, '/');
				let filename = path.replace(/.*\//, '').replace(/\.jpeg/, '').replace(/\.webp/, '');

				if (callFlag) {
					filename += '.webp';
				} else {
					filename += '_288x187.webp';
				}
				return this.$storageURL + 'images/video/' + filename;
			}
        }
    }

</script>
<style lang="scss">
@import '~@/assets/scss/videos_show.scss';
</style>
